import {Injectable} from '@angular/core';
import {BaseDialogService} from '../../base/src/base-dialog.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ShareComponent} from './share.component';

@Injectable({
  providedIn: 'root'
})
export class ShareDialogService extends BaseDialogService<ShareComponent, any> {

  protected config: MatDialogConfig = {
    minWidth: '20vw'
  };

  constructor(protected matDialog: MatDialog) {
    super(matDialog, ShareComponent);
  }
}
